export default {
  getControlPick: { // 查询采摘记录
    url: '/api/getControlPick',
    method: 'get'
  },
  createRawMaterialsStock: { // 新增原料
    url: '/api/createRawMaterialsStock',
    method: 'post'
  },
  updateRawMaterialsStock: { // 修改原料
    url: '/api/updateRawMaterialsStock',
    method: 'put'
  },
  deleteRawMaterialsStock: { // 删除原料
    url: '/api/deleteRawMaterialsStock',
    method: 'delete'
  },
  getRawMaterialsStockList: { // 查询原料
    url: '/api/getRawMaterialsStockList',
    method: 'get'
  }
}
